import { Box } from "@mui/material";
import styled from "styled-components";

export const PageHeader = styled(Box).attrs({
  component: "header",
})`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;
